import BConfig from "../../Modules/BConfig";
import BRequest from "../../modules/BRequest";

export default class BUserIngredientsTable
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.user-ingredients-table`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			const selector = `${this.selector()}__delete-button`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				const row = event.target.closest(`[data-id]`);
				const table = event.target.closest(this.selector());

				row.classList.add("disabled");

				let url = BConfig.getRoute("api.v2.userIngredients.delete")
					.replace("{userIngredientId}", row.dataset.id)
					;

				BRequest.delete(url).then(response => {
					row.remove();
				}).catch(error => {
					row.classList.remove("disabled");
				}).finally(() => {
					if (!table.querySelectorAll(`tbody tr`).length) {
						table.hidden = true;
						document.querySelector(`.user-ingredients-table-no-data`).hidden = false;
					}
				});
			}
		});
	}
}
